<div class="pt-3">
    <div class="mb-2 font-weight-bold">Sessies</div>
    @if (loading) {
        <div class="d-flex justify-content-center p-3">
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Laden...</span>
            </div>
        </div>
    } @else if (sessions.length > 0) {
        <div class="table-responsive">
            <table class="table w-100 mb-3">
                <thead>
                    <tr>
                        <th scope="col">Applicatie</th>
                        <th scope="col">Apparaat</th>
                        <th scope="col">Ingelogd op</th>
                        <th scope="col">Laatst actief</th>
                        <th scope="col">Verloopt op</th>
                        <th scope="col">Laatste locatie</th>
                        <th scope="col">Status</th>
                    </tr>
                </thead>
                <tbody>
                    @for (session of sessions; track session.id) {
                        <tr>
                            <td>
                                {{ session.type }}
                                @if (session.is_current) {
                                    <span class="badge bg-primary ms-1">Deze sessie</span>
                                }
                                @if (session.session_type === 'impersonation') {
                                    <div class="small text-muted">
                                        Overgenomen door {{ session.impersonated_by?.name ?? 'onbekend' }}
                                    </div>
                                }
                            </td>
                            <td>
                                {{ session.device_name ?? '-' }}
                                <div class="small text-muted">{{ session.device_type }}</div>
                            </td>
                            <td>{{ session.created_at | date: 'EEE d MMM y HH:mm' : '' : 'nl' }}</td>
                            <td>{{ (session.last_activity_at | date: 'EEE d MMM y HH:mm' : '' : 'nl') ?? '-' }}</td>
                            <td>{{ (session.expires_at | date: 'EEE d MMM y HH:mm' : '' : 'nl') ?? '-' }}</td>
                            <td>
                                @if (session.latest_location) {
                                    <a
                                        [href]="'https://www.google.com/maps?q=' + session.latest_location"
                                        [title]="session.latest_location"
                                        target="_blank"
                                        rel="noopener noreferrer">
                                        {{ session.latest_municipality ?? session.latest_location }}
                                    </a>
                                } @else {
                                    -
                                }
                            </td>
                            <td>
                                <span
                                    [class]="
                                        { Actief: 'text-success', Ingetrokken: 'text-danger', Verlopen: 'text-muted' }[
                                            status(session)
                                        ]
                                    ">
                                    {{ status(session) }}
                                </span>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    } @else {
        <div class="alert alert-info" role="alert">Geen sessies gevonden.</div>
    }
</div>
